import { defineComponent } from 'vue';
import Warning from '../../../../../../../assets/icons/circle-danger.svg.js';
import __vue_component__$1 from '../../../../../../alerts/Pane/Pane.vue.js';
import __vue_component__ from '../../../../../../cards/BasicCard/BasicCard.vue.js';

var script = defineComponent({
    name: 'ChartingTubeLabelWarning',
    components: {
        BasicCard: __vue_component__,
        CircleDanger: Warning,
        Pane: __vue_component__$1,
    },
    props: {
        isOpened: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            default: 'Label tubes to proceed',
        },
        footer: {
            type: Object,
            default: undefined,
        },
    },
    emits: ['close'],
    setup: () => ({}),
});

export { script as default };
